export default __webpack_public_path__ + "static/media/beneficiarioWeb.b553e824.gif";